module.exports = __webpack_public_path__ + "media/images/add-user-icon-1a3f86b29ea56da19eed27bbe54b9ed6.svg";